export class AddLine {
  static readonly type = '[Contract.Line] Add Line';
  constructor(public line: any) {}
}

export class UpdateLine {
  static readonly type = '[Contract.Line] Update Line';
  constructor(public line: any) {}
}

export class DeleteLine {
  static readonly type = '[Contract.Line] Delete Line';
  constructor(public lineID: number) {}
}

export class RestoreLine {
  static readonly type = '[Contract.Line] Restore Line';
  constructor(public lineID: number) {}
}

export class SetPrimaryLine {
  static readonly type = '[Contract.Line] Set Primary Line';
  constructor(public primary: any) {}
}

export class AddContractDetailItem {
  static readonly type = '[Contract.Line] Add Contract Detail Item';
  constructor(public lineID: string, public articleID: string, public articleNodeType: string) {}
}

export class RemoveContractDetailItem {
  static readonly type = '[Contract.Line] Remove Contract Detail Item';
  constructor(public lineID: string, public articleID: string, public articleNodeType: string) {}
}

export class AddContractPartyItem {
  static readonly type = '[Contract.Line] Add Contract Party Item';
  constructor(public lineID: string, public partyID: string, public partyNodeType: string) {}
}

export class RemoveContractPartyItem {
  static readonly type = '[Contract.Line] Remove Contract Party Item';
  constructor(public lineID: string, public partyID: string, public partyNodeType: string) {}
}

export class AddFormPointer {
  static readonly type = '[Contract.Line] Add Form Pointer';
  constructor(public lineID: string, public articleID: string) {}
}

export class RemoveFormPointer {
  static readonly type = '[Contract.Line] Remove Form Pointer';
  constructor(public lineID: string, public articleID: string) {}
}

export class AddFactorPointer {
  static readonly type = '[Contract.Line] Add Factor Pointer';
  constructor(public lineID: string, public factorID: string) {}
}

export class RemoveFactorPointer {
  static readonly type = '[Contract.Line] Remove Factor Pointer';
  constructor(public lineID: string, public factorID: string) {}
}
